var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getURL())?_c('iframe',{attrs:{"src":_vm.getURL(),"type":"text/html","width":"500","height":"282","frameborder":"0","allowfullscreen":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }